export default {
  name: "Emër",
  tel: "Telefonoj",
  save: "ruaj",
  confirm: "konfirmoj",
  cancel: "Anuloj",
  delete: "nxjerr",
  complete: "Mbaroj",
  loading: "Duke ngarkuar ...",
  telEmpty: "Ju lutemi plotësoni numrin tuaj të telefonit",
  nameEmpty: "Ju lutemi plotësoni emrin tuaj",
  nameInvalid: "Ju lutemi shkruani një emër të vlefshëm",
  confirmDelete: "A jeni i sigurt që doni ta fshini atë",
  telInvalid: "Ju lutemi shkruani numrin e saktë të telefonit",
  vanCalendar: {
    end: "Mbaroj",
    start: "filloj",
    title: "titull",
    confirm: "konfirmoj",
    startEnd: "Filloj",
    weekdays: {
      "0": "ditë",
      "1": "një",
      "2": "dy",
      "3": "tre",
      "4": "Katër",
      "5": "pesë",
      "6": "gjashtë"
    }
  },
  vanCascader: { select: "Ju lutemi zgjidhni" },
  vanContactCard: { addText: "Shto një kontakt" },
  vanContactList: { addText: "Person i ri kontakti" },
  vanPagination: { prev: "Faqe e mëparshme", next: "Faqja tjetër" },
  vanPullRefresh: {
    pulling: "Tërhiqeni për të rifreskuar ...",
    loosing: "Lëshoni rifreskimin ..."
  },
  vanSubmitBar: { label: "Të gjitha:" },
  vanCoupon: { unlimited: "Nuk ka kufizime të përdorimit" },
  vanCouponCell: { title: "Kuponë", tips: "Nuk është në dispozicion" },
  vanCouponList: {
    empty: "Pa kuponë",
    exchange: "këmbim",
    close: "Pa kuponë",
    enable: "I disponueshëm",
    disabled: "Nuk është në dispozicion",
    placeholder: "Ju lutemi shkruani kodin e zbritjes"
  },
  vanAddressEdit: {
    area: "zonë",
    postal: "kod postar",
    areaEmpty: "Zgjidhni një rajon",
    addressEmpty: "Ju lutemi plotësoni adresën e detajuar",
    postalEmpty: "Formati i kodit postar është i pasaktë",
    defaultAddress: "Vendosni si adresën e paracaktuar të transportit",
    telPlaceholder: "Numri celular i marrësit",
    namePlaceholder: "Emri i marrësit",
    areaPlaceholder: "Zgjidhni një krahinë/qytet/rreth"
  },
  vanAddressEditDetail: {
    label: "adresoj",
    placeholder:
      "Numri i derës së rrugës, numri i dhomës së dyshemesë dhe informacione të tjera"
  },
  vanAddressList: { add: "Shto një adresë" }
};
